import type { SiteAccess } from "@convex/schemas/validators/siteAccess.lib";
import { resolveSiteAccess, siteAccessKey, type SiteAccessHolder } from "@shared/addresses/site-access";

export interface ShipmentAccessFacts {
  siteAccess?: SiteAccess;
  hasDockOnSite: boolean;
}

export function shipmentSiteAccess(shipment: ShipmentAccessFacts): SiteAccess {
  return shipment.siteAccess ?? { dock: shipment.hasDockOnSite };
}

export function siteAccessPatch(access: SiteAccess): Required<ShipmentAccessFacts> {
  return { siteAccess: access, hasDockOnSite: access.dock === true };
}

export function savedAddressAccess(address: SiteAccessHolder | undefined): SiteAccess | undefined {
  return address ? resolveSiteAccess(address) : undefined;
}

export function sameSiteAccess(left: ShipmentAccessFacts, right: ShipmentAccessFacts): boolean {
  return siteAccessKey(shipmentSiteAccess(left)) === siteAccessKey(shipmentSiteAccess(right));
}
